module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDhkZGViYmRkNDk5NDM1NzFjZThmNGEyYzY1Y2IzNDUucG5nIjs="